// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"fecd9582","723":"ee4581c6"}[chunkId] + ".chunk.js";
};